import { ChangeEventHandler } from 'react';
import { Search } from 'lucide-react';

import { Input } from '@/components/ui/input';
import InputClearButton from '@/components/input-clear-button';
import { cn } from '@/lib/utils';

interface Props {
  searchInput?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClear: () => void;
  componentId?: string;
  placeholder?: string;
  disabled?: boolean;
  wrapperClassName?: string;
}

export default function SearchInput({
  searchInput,
  onChange,
  onClear,
  componentId,
  placeholder,
  disabled = false,
  wrapperClassName,
}: Props) {
  return (
    <div className={cn('relative w-48', wrapperClassName)}>
      <Search className="text-muted-foreground absolute top-2.5 left-2 size-4" />
      <Input
        className="pl-8"
        disabled={disabled}
        id={componentId}
        name="search"
        onChange={onChange}
        placeholder={placeholder || 'Search'}
        type="text"
        value={searchInput}
      />
      {searchInput && <InputClearButton onClick={onClear} />}
    </div>
  );
}
